var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.75C13.0335 7.75 12.25 8.5335 12.25 9.5V21.5C12.25 22.4665 13.0335 23.25 14 23.25H32C32.9665 23.25 33.75 22.4665 33.75 21.5V9.5C33.75 8.5335 32.9665 7.75 32 7.75H14Z",
    fill: "#ECEFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7.75V23.25H14C13.0335 23.25 12.25 22.4665 12.25 21.5V9.5C12.25 8.5335 13.0335 7.75 14 7.75H23Z",
    fill: "#CFD8DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 11.25H33.75V12.75H12.25V11.25Z",
    fill: "#8B98A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 19C14.75 18.5858 15.0858 18.25 15.5 18.25H20.5C20.9142 18.25 21.25 18.5858 21.25 19C21.25 19.4142 20.9142 19.75 20.5 19.75H15.5C15.0858 19.75 14.75 19.4142 14.75 19Z",
    fill: "#7D8995"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13.75C24.8244 13.75 22.25 16.3244 22.25 19.5C22.25 22.6756 24.8244 25.25 28 25.25C31.1756 25.25 33.75 22.6756 33.75 19.5C33.75 16.3244 31.1756 13.75 28 13.75Z",
    fill: "#5E94FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 13.75V25.25C24.8244 25.25 22.25 22.6756 22.25 19.5C22.25 16.3244 24.8244 13.75 28 13.75Z",
    fill: "#5485E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.75 19.5C24.75 19.0858 25.0858 18.75 25.5 18.75H30.5C30.9142 18.75 31.25 19.0858 31.25 19.5C31.25 19.9142 30.9142 20.25 30.5 20.25H25.5C25.0858 20.25 24.75 19.9142 24.75 19.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 22.75C27.5858 22.75 27.25 22.4142 27.25 22V17C27.25 16.5858 27.5858 16.25 28 16.25C28.4142 16.25 28.75 16.5858 28.75 17V22C28.75 22.4142 28.4142 22.75 28 22.75Z",
    fill: "#ECEFF1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 16.25C27.5858 16.25 27.25 16.5858 27.25 17V18.75H25.5C25.0858 18.75 24.75 19.0858 24.75 19.5C24.75 19.9142 25.0858 20.25 25.5 20.25H27.25V22C27.25 22.4142 27.5858 22.75 28 22.75V16.25Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.25V12.75H13H12.25V11.25H13H23Z",
    fill: "#7D8995"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardAdd);
export default __webpack_public_path__ + "static/media/CreditCardAdd.e8cd7a95278fae946581ea22a52984ea.svg";
export { ForwardRef as ReactComponent };